// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── builder shell ─── */
.studio-flipbook-builder {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #e8eaed;
  color: #1f2937;
  overflow: hidden;
}

/* ─── top bar ─── */
.studio-flipbook-topbar {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 64px;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.studio-flipbook-back {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  color: #4b5563;
  border-radius: 6px;
}

.studio-flipbook-back:hover {
  background: #f3f4f6;
}

.studio-flipbook-title {
  flex: 1 1;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.studio-flipbook-topbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.studio-flipbook-topbar-actions button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
}

.studio-flipbook-topbar-actions button:hover {
  background: #f9fafb;
}

.studio-flipbook-publish {
  background: #4648d4 !important;
  color: #fff !important;
  border-color: #4648d4 !important;
}

.studio-flipbook-save-status {
  font-size: 11px;
  color: #6b7280;
}

/* ─── body ─── */
.studio-flipbook-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
}

/* ─── left panel ─── */
.studio-flipbook-left {
  flex-shrink: 0;
  width: 280px;
  background: #ffffff;
  border-right: 1px solid rgba(15, 23, 42, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.studio-flipbook-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px 12px;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
  flex-shrink: 0;
}

.studio-flipbook-icon-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #2563eb;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 6px;
}

.studio-flipbook-icon-btn:hover {
  background: rgba(31, 58, 52, 0.1);
}

.studio-flipbook-thumbnails {
  padding: 12px 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.studio-flipbook-thumb-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.studio-flipbook-thumb {
  border: 1.5px solid rgba(15, 23, 42, 0.1);
  border-radius: 10px;
  padding: 0;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.studio-flipbook-thumb:hover {
  border-color: rgba(31, 58, 52, 0.35);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.1);
}

.studio-flipbook-thumb-wrapper.selected .studio-flipbook-thumb {
  border-color: #2563eb;
  box-shadow:
    0 0 0 1px #2563eb,
    0 6px 18px rgba(31, 58, 52, 0.18);
}

.studio-flipbook-thumb .studio-flipbook-page-outer {
  border-radius: 0;
  pointer-events: none;
}

.studio-flipbook-thumb-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #64748b;
  margin: 0;
  padding: 6px 8px 8px;
  text-align: center;
  background: #ffffff;
}

.studio-flipbook-thumb-wrapper.selected .studio-flipbook-thumb-label {
  color: #2563eb;
}

.studio-flipbook-thumb-actions {
  display: flex;
  gap: 2px;
  justify-content: center;
  opacity: 0.55;
  transition: opacity 0.15s ease;
}

.studio-flipbook-thumb-wrapper:hover .studio-flipbook-thumb-actions,
.studio-flipbook-thumb-wrapper.selected .studio-flipbook-thumb-actions {
  opacity: 1;
}

.studio-flipbook-thumb-actions button {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #94a3b8;
  font-size: 11px;
  padding: 4px 6px;
  border-radius: 6px;
  line-height: 1;
}

.studio-flipbook-thumb-actions button:hover {
  color: #2563eb;
  background: rgba(31, 58, 52, 0.1);
}

.studio-flipbook-thumb-actions button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* ─── center canvas ─── */
.studio-flipbook-center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-width: 0;
}

.studio-flipbook-canvas-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 880px;
}

.studio-flipbook-canvas {
  flex: 1 1;
  width: 100%;
  max-width: 720px;
  aspect-ratio: 16 / 10;
  min-height: 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  transform-origin: center center;
  transition: transform 0.15s ease;
  overflow: hidden;
  background: #fff;
}

.studio-flipbook-nav {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.studio-flipbook-nav:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.studio-flipbook-page-indicator {
  margin-top: 10px;
  font-size: 12px;
  color: #6b7280;
}

/* ─── right panel ─── */
.studio-flipbook-right {
  flex-shrink: 0;
  width: 340px;
  background: #fff;
  border-left: 1px solid #e5e7eb;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.studio-flipbook-tabs {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.studio-flipbook-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 2px solid transparent;
}

.studio-flipbook-tab.active {
  color: #4648d4;
  border-bottom-color: #4648d4;
}

.studio-flipbook-section {
  padding: 14px 16px;
  border-bottom: 1px solid #f3f4f6;
}

.studio-flipbook-section h3 {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
}

.studio-flipbook-section select,
.studio-flipbook-section input[type='range'] {
  width: 100%;
}

.studio-flipbook-section select {
  padding: 7px 9px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
}

.studio-flipbook-section input[type='color'] {
  width: 100%;
  height: 34px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
}

.studio-flipbook-textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  resize: vertical;
  font-family: inherit;
}

.studio-flipbook-range-val {
  font-size: 11px;
  color: #6b7280;
  margin-left: 6px;
}

.studio-flipbook-range-label {
  display: block;
  font-size: 11px;
  color: #6b7280;
  margin: 6px 0 2px;
}

.studio-flipbook-reset-btn {
  width: 100%;
  margin-top: 8px;
  padding: 7px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #4b5563;
}

.studio-flipbook-reset-btn:hover {
  background: #f3f4f6;
}

.studio-flipbook-image-pan,
.studio-flipbook-frame-move-handle {
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.studio-flipbook-interactive-el {
  touch-action: none;
}

.studio-flipbook-edge-zone {
  touch-action: none;
  background: transparent;
}

.studio-flipbook-edge-zone:hover {
  background: rgba(99, 102, 241, 0.08);
}

.studio-flipbook-interactive-el.studio-flipbook-interactive-el--dragging {
  z-index: 999 !important;
}

.studio-flipbook-ctx-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10040;
  background: transparent;
}

.studio-flipbook-ctx-menu {
  position: fixed;
  z-index: 10050;
  min-width: 220px;
  max-width: min(280px, calc(100vw - 24px));
  max-height: min(72vh, calc(100vh - 24px));
  overflow-x: hidden;
  overflow-y: auto;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.22);
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.studio-flipbook-ctx-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #1f2937;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.studio-flipbook-ctx-item:hover {
  background: #eef2ff;
  color: #4338ca;
}

.studio-flipbook-ctx-item--danger {
  color: #dc2626;
}

.studio-flipbook-ctx-item--danger:hover {
  background: #fef2f2;
  color: #b91c1c;
}

.studio-flipbook-ctx-hint {
  font-size: 10px;
  font-weight: 500;
  color: #9ca3af;
}

.studio-flipbook-ctx-divider {
  height: 1px;
  margin: 4px 6px;
  background: #f3f4f6;
}

.studio-flipbook-ctx-item--selected {
  background: #eef2ff;
  color: #4338ca;
}

.studio-flipbook-ctx-submenu {
  margin: 2px 0;
}

.studio-flipbook-ctx-submenu-row {
  display: flex;
  align-items: stretch;
  gap: 2px;
  border-radius: 8px;
  overflow: hidden;
}

.studio-flipbook-ctx-submenu-row.is-open {
  background: #ffffff;
}

.studio-flipbook-ctx-submenu-label-btn {
  display: flex;
  flex: 1 1;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 8px 10px;
  border: none;
  background: transparent;
  color: #1f2937;
  text-align: left;
  cursor: pointer;
}

.studio-flipbook-ctx-submenu-label-btn:hover,
.studio-flipbook-ctx-submenu-row.is-open .studio-flipbook-ctx-submenu-label-btn {
  color: #4338ca;
}

.studio-flipbook-ctx-submenu-text {
  min-width: 0;
}

.studio-flipbook-ctx-submenu-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  flex-shrink: 0;
  border: none;
  border-left: 1px solid #f3f4f6;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
}

.studio-flipbook-ctx-submenu-arrow:hover,
.studio-flipbook-ctx-submenu-row.is-open .studio-flipbook-ctx-submenu-arrow {
  background: #eef2ff;
  color: #6366f1;
}

.studio-flipbook-ctx-submenu-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
}

.studio-flipbook-ctx-submenu-value {
  display: block;
  margin-top: 1px;
  font-size: 10px;
  font-weight: 500;
  color: #9ca3af;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.studio-flipbook-ctx-chevron {
  flex-shrink: 0;
  font-size: 11px;
}

.studio-flipbook-ctx-flyout {
  position: fixed;
  z-index: 10060;
  max-height: min(70vh, calc(100vh - 24px));
  overflow-x: hidden;
  overflow-y: auto;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.22);
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.studio-flipbook-ctx-flyout--shapes {
  max-height: min(80vh, calc(100vh - 24px));
}

.studio-flipbook-ctx-flyout--controls {
  padding: 8px;
}

.studio-flipbook-ctx-slider-row {
  padding: 8px 8px 10px;
}

.studio-flipbook-ctx-slider-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.studio-flipbook-ctx-slider-val {
  font-size: 11px;
  font-weight: 600;
  color: #6366f1;
}

.studio-flipbook-ctx-slider-row input[type='range'] {
  width: 100%;
  accent-color: #6366f1;
}

.studio-flipbook-inner-zoom-handle:hover {
  transform: scale(1.05);
}

.studio-flipbook-ctx-color-swatch {
  display: block;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.studio-flipbook-ctx-group-label {
  padding: 6px 8px 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #9ca3af;
}

.studio-flipbook-ctx-shape-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #374151;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.studio-flipbook-ctx-shape-item:hover {
  background: #eef2ff;
  color: #4338ca;
}

.studio-flipbook-ctx-shape-item.is-selected {
  background: #e0e7ff;
  color: #4338ca;
  font-weight: 600;
}

.studio-flipbook-ctx-shape-preview {
  display: block;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.25);
}

.studio-flipbook-ctx-check {
  margin-left: auto;
  font-size: 12px;
  font-weight: 700;
  color: #6366f1;
}

.studio-flipbook-frame-move-handle {
  border-bottom: 1px solid rgba(255, 255, 255, 0.35);
  letter-spacing: 0.02em;
}

.studio-flipbook-hint {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
}

.studio-flipbook-align-btns {
  display: flex;
  gap: 6px;
}

.studio-flipbook-align-btns button {
  flex: 1 1;
  padding: 6px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
}

.studio-flipbook-align-btns button.active {
  background: #eef2ff;
  border-color: #4648d4;
  color: #4648d4;
}

.studio-flipbook-swap-btn {
  width: 100%;
  padding: 8px;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  font-size: 13px;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.studio-flipbook-swap-btn:hover {
  background: #eef2ff;
  border-color: #4648d4;
  color: #4648d4;
}

.studio-flipbook-slot-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.studio-flipbook-slot-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  width: 100%;
}

.studio-flipbook-slot-btn.selected {
  border-color: #4648d4;
  background: #eef2ff;
}

.studio-flipbook-slot-btn img {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 4px;
}

.studio-flipbook-slot-empty {
  width: 32px;
  height: 32px;
  background: #e5e7eb;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: #9ca3af;
}

.studio-flipbook-slot-label {
  font-size: 11px;
  color: #6b7280;
  text-transform: capitalize;
}

.studio-flipbook-text-slot-preview {
  flex: 1 1;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.studio-flipbook-regenerate {
  width: 100%;
  padding: 9px;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  font-size: 13px;
  color: #4b5563;
}

.studio-flipbook-regenerate:hover {
  background: #eef2ff;
  border-color: #4648d4;
  color: #4648d4;
}

.studio-flipbook-page-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.studio-flipbook-page-actions button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #4b5563;
}

.studio-flipbook-page-actions button:hover {
  background: #f3f4f6;
}

.studio-flipbook-page-actions button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ─── image library modal ─── */
.studio-flipbook-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.62);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.studio-flipbook-modal {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 720px;
  max-height: 84vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.25);
}

.studio-flipbook-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.studio-flipbook-modal-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.studio-flipbook-modal-header button {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  color: #6b7280;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.studio-flipbook-modal-header button:hover {
  background: #f3f4f6;
  color: #111827;
}

/* ─── choose image modal ─── */
.studio-flipbook-choose-image-modal {
  width: min(92vw, 640px) !important;
  height: min(82vh, 500px) !important;
  max-width: 640px !important;
  max-height: 500px !important;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}

.studio-flipbook-choose-image-modal .studio-flipbook-modal-header {
  flex-shrink: 0;
  padding: 12px 16px;
}

.studio-flipbook-choose-image-modal .studio-flipbook-modal-header h3 {
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.studio-flipbook-image-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4648d4;
  font-size: 11px;
  font-weight: 700;
}

/* Inner scroll — only this area scrolls */
.studio-flipbook-choose-image-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  background: #ffffff;
}

.studio-flipbook-choose-image-initial-load {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 16px;
  color: #6b7280;
  font-size: 13px;
}

.studio-flipbook-choose-image-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 16px;
  color: #dc2626;
  font-size: 13px;
  text-align: center;
}

.studio-flipbook-choose-image-error-msg {
  color: #6b7280;
  font-size: 12px;
  margin: 0;
}

/* Fixed-size grid like photo-studio gallery */
.studio-flipbook-choose-image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 104px);
  gap: 10px;
  padding: 14px 16px 8px;
  justify-content: center;
}

@media (max-width: 480px) {
  .studio-flipbook-choose-image-grid {
    grid-template-columns: repeat(auto-fill, 96px);
    gap: 8px;
    padding: 12px;
  }

  .studio-flipbook-modal-thumb {
    width: 96px;
    height: 96px;
  }
}

/* ── thumbnail — fixed square, same as client-images cards ── */
.studio-flipbook-modal-thumb {
  position: relative;
  width: 104px;
  height: 104px;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(204, 195, 216, 0.35);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: #eceef0;
  display: block;
  box-shadow: 0 1px 2px rgba(25, 28, 30, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.studio-flipbook-modal-thumb:hover {
  border-color: #630ed4;
  box-shadow: 0 4px 16px rgba(99, 14, 212, 0.18);
  transform: translateY(-1px);
}

.studio-flipbook-modal-thumb:focus-visible {
  outline: 3px solid rgba(99, 14, 212, 0.35);
  outline-offset: 2px;
}

.studio-flipbook-modal-thumb-inner {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #e5e7eb;
}

.studio-flipbook-modal-thumb-inner > div {
  position: absolute;
  inset: 0;
}

.studio-flipbook-modal-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* skeleton shimmer */
.studio-flipbook-thumb-skeleton {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 48%, #e5e7eb 100%);
  background-size: 220% 100%;
  animation: studio-flipbook-shimmer 1.2s ease-in-out infinite;
}

@keyframes studio-flipbook-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.studio-flipbook-modal-thumb-error {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fee2e2;
  color: #b91c1c;
  font-weight: 700;
  font-size: 16px;
}

/* Footer inside scroll area */
.studio-flipbook-choose-image-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px 16px;
}

.studio-flipbook-loading-more {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #6b7280;
  font-size: 12px;
}

.studio-flipbook-all-loaded {
  color: #9ca3af;
  font-size: 11px;
  padding-bottom: 4px;
}

.studio-flipbook-load-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #fff;
  color: #374151;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
}

.studio-flipbook-load-more-btn:hover {
  background: #f3f4f6;
  border-color: #630ed4;
  box-shadow: 0 2px 8px rgba(99, 14, 212, 0.12);
}

/* ─── loading / error ─── */
.studio-flipbook-loading,
.studio-flipbook-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  gap: 14px;
  color: #4b5563;
}

/* ─── layout picker modal ─── */
.layout-picker-modal {
  max-width: 720px !important;
}

.layout-picker-grid {
  padding: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  overflow-y: auto;
  max-height: 60vh;
}

.layout-picker-card {
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  position: relative;
  transition: border-color 0.15s;
}

.layout-picker-card:hover {
  border-color: #4648d4;
}

.layout-picker-card.selected {
  border-color: #4648d4;
  background: #eef2ff;
}

.layout-picker-preview {
  margin-bottom: 6px;
}

.layout-picker-svg {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.layout-picker-name {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
}

.layout-picker-meta {
  display: block;
  font-size: 10px;
  color: #6b7280;
  margin-top: 2px;
}

.layout-picker-check {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #4648d4;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.layout-picker-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
}

.layout-picker-cancel {
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
}

.layout-picker-confirm {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: #4648d4;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
}

.layout-picker-confirm:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ─── flipbook preview — photo-theme style ─── */
.studio-flipbook-preview-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
}

.studio-flipbook-preview-photo-theme {
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #0f0f14, #16161d, #1a1a24);
}

.studio-flipbook-preview-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.studio-flipbook-preview-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.studio-flipbook-preview-brand-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
}

.studio-flipbook-preview-brand-title {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}

.studio-flipbook-preview-brand-sub {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 1px;
}

.studio-flipbook-preview-topbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.studio-flipbook-preview-view-toggle,
.studio-flipbook-preview-orientation-toggle {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 2px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  gap: 2px;
}

.studio-flipbook-preview-view-toggle button,
.studio-flipbook-preview-orientation-toggle button {
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.4);
  font-size: 10px;
  font-weight: 700;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.studio-flipbook-preview-view-toggle button.active,
.studio-flipbook-preview-orientation-toggle button.active {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.studio-flipbook-preview-view-toggle button:hover:not(.active),
.studio-flipbook-preview-orientation-toggle button:hover:not(.active) {
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 720px) {
  .studio-flipbook-preview-orientation-toggle {
    display: none;
  }
}

.studio-flipbook-preview-dl-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  border: none;
  background: rgba(99, 102, 241, 0.8);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.studio-flipbook-preview-dl-btn:hover {
  background: #6366f1;
}

.studio-flipbook-preview-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.studio-flipbook-preview-close-btn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.studio-flipbook-preview-stage-photo {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 24px 16px;
  min-height: 0;
}

.studio-flipbook-preview-spotlight {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.studio-flipbook-preview-spotlight::after {
  content: '';
  width: 50%;
  height: 60%;
  border-radius: 50%;
  background: rgba(99, 102, 241, 0.04);
  filter: blur(100px);
}

.studio-flipbook-preview-nav-photo {
  position: absolute;
  z-index: 30;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  padding: 12px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.studio-flipbook-preview-nav-photo.prev { left: 16px; }
.studio-flipbook-preview-nav-photo.next { right: 16px; }

.studio-flipbook-preview-nav-photo:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
}

.studio-flipbook-preview-nav-photo:disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

.studio-flipbook-preview-book-wrap-photo {
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.studio-flipbook-book-photo {
  width: 100% !important;
  height: 100% !important;
  border-radius: 12px;
  box-shadow: 0 30px 100px rgba(0, 0, 0, 0.6);
}

.studio-flipbook-book-photo .stf__parent {
  width: 100% !important;
  height: 100% !important;
}

.studio-flipbook-flip-page {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
}

.studio-flipbook-flip-page-inner {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.studio-flipbook-page-preview-frame {
  position: relative;
  z-index: 20;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  flex-shrink: 0;
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.1),
    0 20px 60px rgba(0, 0, 0, 0.3),
    0 40px 100px -20px rgba(0, 0, 0, 0.5),
    inset 0 0 0 1px rgba(255, 255, 255, 0.05);
}

.studio-flipbook-page-outer--fill {
  background: #fff;
}

.studio-flipbook-page-scaler {
  line-height: 0;
}

.studio-flipbook-preview-size-hint {
  color: rgba(255, 255, 255, 0.35);
  font-weight: 500;
  margin-left: 4px;
}

.studio-flipbook-preview-surface-shadow {
  position: absolute;
  bottom: 6%;
  left: 50%;
  transform: translateX(-50%);
  width: 35%;
  height: 16px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  filter: blur(16px);
  pointer-events: none;
}

.studio-flipbook-preview-bottombar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 24px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.studio-flipbook-preview-page-count {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
}

.studio-flipbook-preview-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 40vw;
  overflow-x: auto;
  padding: 2px 4px;
}

.studio-flipbook-preview-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: none;
  padding: 0;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
}

.studio-flipbook-preview-dot.past {
  background: rgba(255, 255, 255, 0.3);
}

.studio-flipbook-preview-dot.active {
  width: 16px;
  border-radius: 999px;
  background: #818cf8;
}

.studio-flipbook-preview-hint {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.3);
}

/* legacy preview classes kept for compatibility */
.studio-flipbook-preview-overlay.legacy {
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}

.studio-flipbook-preview-modal {
  width: 90vw;
  max-width: 1100px;
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.studio-flipbook-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  color: #fff;
}

.studio-flipbook-preview-header h3 {
  margin: 0;
  font-size: 16px;
}

.studio-flipbook-preview-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.studio-flipbook-preview-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  font-size: 13px;
}

.studio-flipbook-preview-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.studio-flipbook-preview-close {
  border: none;
  background: transparent;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
}

.studio-flipbook-preview-stage {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 0;
  overflow: hidden;
}

.studio-flipbook-preview-book-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.studio-flipbook-preview-nav {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
}

.studio-flipbook-preview-nav:disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

.studio-flipbook-preview-nav:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
}

.studio-flipbook-preview-footer {
  text-align: center;
  padding: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

.studio-flipbook-preview-page {
  background: #fff;
}

.studio-flipbook-book {
  margin: 0 auto;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
}

.studio-flipbook-page-outer {
  line-height: 0;
}

/* ─── responsive ─── */
@media (max-width: 1100px) {
  .studio-flipbook-right {
    display: none;
  }

  .studio-flipbook-left {
    width: 240px;
  }
}

@media (max-width: 768px) {
  .studio-flipbook-topbar {
    height: auto;
    min-height: 58px;
    flex-wrap: wrap;
    padding: 10px 12px;
  }

  .studio-flipbook-left {
    display: none;
  }

  .studio-flipbook-center {
    padding: 12px;
  }

  .studio-flipbook-canvas-wrap {
    gap: 6px;
  }

  .studio-flipbook-nav {
    width: 28px;
    height: 28px;
  }

  .studio-flipbook-modal-overlay {
    padding: 12px;
  }

  .studio-flipbook-choose-image-modal {
    width: 96vw !important;
    height: min(88vh, 480px) !important;
    max-height: none !important;
    border-radius: 14px;
  }
}

@media (max-width: 420px) {
  .studio-flipbook-choose-image-grid {
    grid-template-columns: repeat(auto-fill, 88px);
  }

  .studio-flipbook-modal-thumb {
    width: 88px;
    height: 88px;
  }

  .studio-flipbook-topbar-actions {
    width: 100%;
    justify-content: flex-end;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/studio-flipbook/studio-flipbook.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAO;EACP,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,+CAA+C;EAC/C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,gFAAgF;AAClF;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB;;qCAEmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;EAC9C,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;EAC9C,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,8CAA8C;IAC9C,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,SAAS;EACT,UAAU;EACV,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,6EAA6E;AAC/E;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,yEAAyE;EACzE,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;;EAEE,qCAAqC;EACrC,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,2CAA2C;EAC3C,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,0CAA0C,UAAU,EAAE;AACtD,0CAA0C,WAAW,EAAE;;AAEvD;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd;;;;6CAI2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,kDAAkD;AAClD;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":["/* ─── builder shell ─── */\n.studio-flipbook-builder {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: #e8eaed;\n  color: #1f2937;\n  overflow: hidden;\n}\n\n/* ─── top bar ─── */\n.studio-flipbook-topbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  height: 64px;\n  padding: 0 16px;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.studio-flipbook-back {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 13px;\n  color: #4b5563;\n  border-radius: 6px;\n}\n\n.studio-flipbook-back:hover {\n  background: #f3f4f6;\n}\n\n.studio-flipbook-title {\n  flex: 1;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.studio-flipbook-topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.studio-flipbook-topbar-actions button {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.studio-flipbook-topbar-actions button:hover {\n  background: #f9fafb;\n}\n\n.studio-flipbook-publish {\n  background: #4648d4 !important;\n  color: #fff !important;\n  border-color: #4648d4 !important;\n}\n\n.studio-flipbook-save-status {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n/* ─── body ─── */\n.studio-flipbook-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n\n/* ─── left panel ─── */\n.studio-flipbook-left {\n  flex-shrink: 0;\n  width: 280px;\n  background: #ffffff;\n  border-right: 1px solid rgba(15, 23, 42, 0.1);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.studio-flipbook-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 14px 12px;\n  font-weight: 700;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.studio-flipbook-icon-btn {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #2563eb;\n  font-size: 14px;\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.studio-flipbook-icon-btn:hover {\n  background: rgba(31, 58, 52, 0.1);\n}\n\n.studio-flipbook-thumbnails {\n  padding: 12px 10px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.studio-flipbook-thumb-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.studio-flipbook-thumb {\n  border: 1.5px solid rgba(15, 23, 42, 0.1);\n  border-radius: 10px;\n  padding: 0;\n  background: #ffffff;\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.studio-flipbook-thumb:hover {\n  border-color: rgba(31, 58, 52, 0.35);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.1);\n}\n\n.studio-flipbook-thumb-wrapper.selected .studio-flipbook-thumb {\n  border-color: #2563eb;\n  box-shadow:\n    0 0 0 1px #2563eb,\n    0 6px 18px rgba(31, 58, 52, 0.18);\n}\n\n.studio-flipbook-thumb .studio-flipbook-page-outer {\n  border-radius: 0;\n  pointer-events: none;\n}\n\n.studio-flipbook-thumb-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: #64748b;\n  margin: 0;\n  padding: 6px 8px 8px;\n  text-align: center;\n  background: #ffffff;\n}\n\n.studio-flipbook-thumb-wrapper.selected .studio-flipbook-thumb-label {\n  color: #2563eb;\n}\n\n.studio-flipbook-thumb-actions {\n  display: flex;\n  gap: 2px;\n  justify-content: center;\n  opacity: 0.55;\n  transition: opacity 0.15s ease;\n}\n\n.studio-flipbook-thumb-wrapper:hover .studio-flipbook-thumb-actions,\n.studio-flipbook-thumb-wrapper.selected .studio-flipbook-thumb-actions {\n  opacity: 1;\n}\n\n.studio-flipbook-thumb-actions button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #94a3b8;\n  font-size: 11px;\n  padding: 4px 6px;\n  border-radius: 6px;\n  line-height: 1;\n}\n\n.studio-flipbook-thumb-actions button:hover {\n  color: #2563eb;\n  background: rgba(31, 58, 52, 0.1);\n}\n\n.studio-flipbook-thumb-actions button:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n/* ─── center canvas ─── */\n.studio-flipbook-center {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  min-width: 0;\n}\n\n.studio-flipbook-canvas-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  max-width: 880px;\n}\n\n.studio-flipbook-canvas {\n  flex: 1;\n  width: 100%;\n  max-width: 720px;\n  aspect-ratio: 16 / 10;\n  min-height: 0;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  transform-origin: center center;\n  transition: transform 0.15s ease;\n  overflow: hidden;\n  background: #fff;\n}\n\n.studio-flipbook-nav {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.studio-flipbook-nav:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.studio-flipbook-page-indicator {\n  margin-top: 10px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* ─── right panel ─── */\n.studio-flipbook-right {\n  flex-shrink: 0;\n  width: 340px;\n  background: #fff;\n  border-left: 1px solid #e5e7eb;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.studio-flipbook-tabs {\n  display: flex;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.studio-flipbook-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 10px 6px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  color: #6b7280;\n  border-bottom: 2px solid transparent;\n}\n\n.studio-flipbook-tab.active {\n  color: #4648d4;\n  border-bottom-color: #4648d4;\n}\n\n.studio-flipbook-section {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.studio-flipbook-section h3 {\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n}\n\n.studio-flipbook-section select,\n.studio-flipbook-section input[type='range'] {\n  width: 100%;\n}\n\n.studio-flipbook-section select {\n  padding: 7px 9px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.studio-flipbook-section input[type='color'] {\n  width: 100%;\n  height: 34px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.studio-flipbook-textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n  resize: vertical;\n  font-family: inherit;\n}\n\n.studio-flipbook-range-val {\n  font-size: 11px;\n  color: #6b7280;\n  margin-left: 6px;\n}\n\n.studio-flipbook-range-label {\n  display: block;\n  font-size: 11px;\n  color: #6b7280;\n  margin: 6px 0 2px;\n}\n\n.studio-flipbook-reset-btn {\n  width: 100%;\n  margin-top: 8px;\n  padding: 7px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 12px;\n  color: #4b5563;\n}\n\n.studio-flipbook-reset-btn:hover {\n  background: #f3f4f6;\n}\n\n.studio-flipbook-image-pan,\n.studio-flipbook-frame-move-handle {\n  touch-action: none;\n  user-select: none;\n}\n\n.studio-flipbook-interactive-el {\n  touch-action: none;\n}\n\n.studio-flipbook-edge-zone {\n  touch-action: none;\n  background: transparent;\n}\n\n.studio-flipbook-edge-zone:hover {\n  background: rgba(99, 102, 241, 0.08);\n}\n\n.studio-flipbook-interactive-el.studio-flipbook-interactive-el--dragging {\n  z-index: 999 !important;\n}\n\n.studio-flipbook-ctx-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10040;\n  background: transparent;\n}\n\n.studio-flipbook-ctx-menu {\n  position: fixed;\n  z-index: 10050;\n  min-width: 220px;\n  max-width: min(280px, calc(100vw - 24px));\n  max-height: min(72vh, calc(100vh - 24px));\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 6px;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.22);\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.studio-flipbook-ctx-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n}\n\n.studio-flipbook-ctx-item:hover {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.studio-flipbook-ctx-item--danger {\n  color: #dc2626;\n}\n\n.studio-flipbook-ctx-item--danger:hover {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.studio-flipbook-ctx-hint {\n  font-size: 10px;\n  font-weight: 500;\n  color: #9ca3af;\n}\n\n.studio-flipbook-ctx-divider {\n  height: 1px;\n  margin: 4px 6px;\n  background: #f3f4f6;\n}\n\n.studio-flipbook-ctx-item--selected {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.studio-flipbook-ctx-submenu {\n  margin: 2px 0;\n}\n\n.studio-flipbook-ctx-submenu-row {\n  display: flex;\n  align-items: stretch;\n  gap: 2px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.studio-flipbook-ctx-submenu-row.is-open {\n  background: #ffffff;\n}\n\n.studio-flipbook-ctx-submenu-label-btn {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 8px 10px;\n  border: none;\n  background: transparent;\n  color: #1f2937;\n  text-align: left;\n  cursor: pointer;\n}\n\n.studio-flipbook-ctx-submenu-label-btn:hover,\n.studio-flipbook-ctx-submenu-row.is-open .studio-flipbook-ctx-submenu-label-btn {\n  color: #4338ca;\n}\n\n.studio-flipbook-ctx-submenu-text {\n  min-width: 0;\n}\n\n.studio-flipbook-ctx-submenu-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  flex-shrink: 0;\n  border: none;\n  border-left: 1px solid #f3f4f6;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n}\n\n.studio-flipbook-ctx-submenu-arrow:hover,\n.studio-flipbook-ctx-submenu-row.is-open .studio-flipbook-ctx-submenu-arrow {\n  background: #eef2ff;\n  color: #6366f1;\n}\n\n.studio-flipbook-ctx-submenu-title {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.studio-flipbook-ctx-submenu-value {\n  display: block;\n  margin-top: 1px;\n  font-size: 10px;\n  font-weight: 500;\n  color: #9ca3af;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.studio-flipbook-ctx-chevron {\n  flex-shrink: 0;\n  font-size: 11px;\n}\n\n.studio-flipbook-ctx-flyout {\n  position: fixed;\n  z-index: 10060;\n  max-height: min(70vh, calc(100vh - 24px));\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 6px;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.22);\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.studio-flipbook-ctx-flyout--shapes {\n  max-height: min(80vh, calc(100vh - 24px));\n}\n\n.studio-flipbook-ctx-flyout--controls {\n  padding: 8px;\n}\n\n.studio-flipbook-ctx-slider-row {\n  padding: 8px 8px 10px;\n}\n\n.studio-flipbook-ctx-slider-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.studio-flipbook-ctx-slider-val {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6366f1;\n}\n\n.studio-flipbook-ctx-slider-row input[type='range'] {\n  width: 100%;\n  accent-color: #6366f1;\n}\n\n.studio-flipbook-inner-zoom-handle:hover {\n  transform: scale(1.05);\n}\n\n.studio-flipbook-ctx-color-swatch {\n  display: block;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);\n}\n\n.studio-flipbook-ctx-group-label {\n  padding: 6px 8px 4px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n\n.studio-flipbook-ctx-shape-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 8px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n}\n\n.studio-flipbook-ctx-shape-item:hover {\n  background: #eef2ff;\n  color: #4338ca;\n}\n\n.studio-flipbook-ctx-shape-item.is-selected {\n  background: #e0e7ff;\n  color: #4338ca;\n  font-weight: 600;\n}\n\n.studio-flipbook-ctx-shape-preview {\n  display: block;\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.25);\n}\n\n.studio-flipbook-ctx-check {\n  margin-left: auto;\n  font-size: 12px;\n  font-weight: 700;\n  color: #6366f1;\n}\n\n.studio-flipbook-frame-move-handle {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.35);\n  letter-spacing: 0.02em;\n}\n\n.studio-flipbook-hint {\n  font-size: 12px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.studio-flipbook-align-btns {\n  display: flex;\n  gap: 6px;\n}\n\n.studio-flipbook-align-btns button {\n  flex: 1;\n  padding: 6px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.studio-flipbook-align-btns button.active {\n  background: #eef2ff;\n  border-color: #4648d4;\n  color: #4648d4;\n}\n\n.studio-flipbook-swap-btn {\n  width: 100%;\n  padding: 8px;\n  border: 1px dashed #d1d5db;\n  border-radius: 6px;\n  background: #fafafa;\n  cursor: pointer;\n  font-size: 13px;\n  color: #4b5563;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.studio-flipbook-swap-btn:hover {\n  background: #eef2ff;\n  border-color: #4648d4;\n  color: #4648d4;\n}\n\n.studio-flipbook-slot-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.studio-flipbook-slot-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n}\n\n.studio-flipbook-slot-btn.selected {\n  border-color: #4648d4;\n  background: #eef2ff;\n}\n\n.studio-flipbook-slot-btn img {\n  width: 32px;\n  height: 32px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.studio-flipbook-slot-empty {\n  width: 32px;\n  height: 32px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  color: #9ca3af;\n}\n\n.studio-flipbook-slot-label {\n  font-size: 11px;\n  color: #6b7280;\n  text-transform: capitalize;\n}\n\n.studio-flipbook-text-slot-preview {\n  flex: 1;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.studio-flipbook-regenerate {\n  width: 100%;\n  padding: 9px;\n  border: 1px dashed #d1d5db;\n  border-radius: 6px;\n  background: #fafafa;\n  cursor: pointer;\n  font-size: 13px;\n  color: #4b5563;\n}\n\n.studio-flipbook-regenerate:hover {\n  background: #eef2ff;\n  border-color: #4648d4;\n  color: #4648d4;\n}\n\n.studio-flipbook-page-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.studio-flipbook-page-actions button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 12px;\n  color: #4b5563;\n}\n\n.studio-flipbook-page-actions button:hover {\n  background: #f3f4f6;\n}\n\n.studio-flipbook-page-actions button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ─── image library modal ─── */\n.studio-flipbook-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.62);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.studio-flipbook-modal {\n  background: #fff;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 720px;\n  max-height: 84vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.25);\n}\n\n.studio-flipbook-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.studio-flipbook-modal-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.studio-flipbook-modal-header button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 16px;\n  color: #6b7280;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.studio-flipbook-modal-header button:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n/* ─── choose image modal ─── */\n.studio-flipbook-choose-image-modal {\n  width: min(92vw, 640px) !important;\n  height: min(82vh, 500px) !important;\n  max-width: 640px !important;\n  max-height: 500px !important;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n}\n\n.studio-flipbook-choose-image-modal .studio-flipbook-modal-header {\n  flex-shrink: 0;\n  padding: 12px 16px;\n}\n\n.studio-flipbook-choose-image-modal .studio-flipbook-modal-header h3 {\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.studio-flipbook-image-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 20px;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: #eef2ff;\n  color: #4648d4;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n/* Inner scroll — only this area scrolls */\n.studio-flipbook-choose-image-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth;\n  background: #ffffff;\n}\n\n.studio-flipbook-choose-image-initial-load {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 48px 16px;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.studio-flipbook-choose-image-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 16px;\n  color: #dc2626;\n  font-size: 13px;\n  text-align: center;\n}\n\n.studio-flipbook-choose-image-error-msg {\n  color: #6b7280;\n  font-size: 12px;\n  margin: 0;\n}\n\n/* Fixed-size grid like photo-studio gallery */\n.studio-flipbook-choose-image-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 104px);\n  gap: 10px;\n  padding: 14px 16px 8px;\n  justify-content: center;\n}\n\n@media (max-width: 480px) {\n  .studio-flipbook-choose-image-grid {\n    grid-template-columns: repeat(auto-fill, 96px);\n    gap: 8px;\n    padding: 12px;\n  }\n\n  .studio-flipbook-modal-thumb {\n    width: 96px;\n    height: 96px;\n  }\n}\n\n/* ── thumbnail — fixed square, same as client-images cards ── */\n.studio-flipbook-modal-thumb {\n  position: relative;\n  width: 104px;\n  height: 104px;\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(204, 195, 216, 0.35);\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  background: #eceef0;\n  display: block;\n  box-shadow: 0 1px 2px rgba(25, 28, 30, 0.05);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.studio-flipbook-modal-thumb:hover {\n  border-color: #630ed4;\n  box-shadow: 0 4px 16px rgba(99, 14, 212, 0.18);\n  transform: translateY(-1px);\n}\n\n.studio-flipbook-modal-thumb:focus-visible {\n  outline: 3px solid rgba(99, 14, 212, 0.35);\n  outline-offset: 2px;\n}\n\n.studio-flipbook-modal-thumb-inner {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #e5e7eb;\n}\n\n.studio-flipbook-modal-thumb-inner > div {\n  position: absolute;\n  inset: 0;\n}\n\n.studio-flipbook-modal-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* skeleton shimmer */\n.studio-flipbook-thumb-skeleton {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 48%, #e5e7eb 100%);\n  background-size: 220% 100%;\n  animation: studio-flipbook-shimmer 1.2s ease-in-out infinite;\n}\n\n@keyframes studio-flipbook-shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.studio-flipbook-modal-thumb-error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fee2e2;\n  color: #b91c1c;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n/* Footer inside scroll area */\n.studio-flipbook-choose-image-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 16px 16px;\n}\n\n.studio-flipbook-loading-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.studio-flipbook-all-loaded {\n  color: #9ca3af;\n  font-size: 11px;\n  padding-bottom: 4px;\n}\n\n.studio-flipbook-load-more-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 20px;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  background: #fff;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n\n.studio-flipbook-load-more-btn:hover {\n  background: #f3f4f6;\n  border-color: #630ed4;\n  box-shadow: 0 2px 8px rgba(99, 14, 212, 0.12);\n}\n\n/* ─── loading / error ─── */\n.studio-flipbook-loading,\n.studio-flipbook-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n  gap: 14px;\n  color: #4b5563;\n}\n\n/* ─── layout picker modal ─── */\n.layout-picker-modal {\n  max-width: 720px !important;\n}\n\n.layout-picker-grid {\n  padding: 16px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n  overflow-y: auto;\n  max-height: 60vh;\n}\n\n.layout-picker-card {\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 8px;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  position: relative;\n  transition: border-color 0.15s;\n}\n\n.layout-picker-card:hover {\n  border-color: #4648d4;\n}\n\n.layout-picker-card.selected {\n  border-color: #4648d4;\n  background: #eef2ff;\n}\n\n.layout-picker-preview {\n  margin-bottom: 6px;\n}\n\n.layout-picker-svg {\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n.layout-picker-name {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.layout-picker-meta {\n  display: block;\n  font-size: 10px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.layout-picker-check {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #4648d4;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n}\n\n.layout-picker-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.layout-picker-cancel {\n  padding: 8px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.layout-picker-confirm {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  background: #4648d4;\n  color: #fff;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.layout-picker-confirm:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ─── flipbook preview — photo-theme style ─── */\n.studio-flipbook-preview-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n}\n\n.studio-flipbook-preview-photo-theme {\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to bottom, #0f0f14, #16161d, #1a1a24);\n}\n\n.studio-flipbook-preview-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 24px;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.studio-flipbook-preview-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.studio-flipbook-preview-brand-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 12px;\n}\n\n.studio-flipbook-preview-brand-title {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 0.02em;\n}\n\n.studio-flipbook-preview-brand-sub {\n  display: block;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.4);\n  margin-top: 1px;\n}\n\n.studio-flipbook-preview-topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.studio-flipbook-preview-view-toggle,\n.studio-flipbook-preview-orientation-toggle {\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 2px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  gap: 2px;\n}\n\n.studio-flipbook-preview-view-toggle button,\n.studio-flipbook-preview-orientation-toggle button {\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 10px;\n  font-weight: 700;\n  padding: 5px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.studio-flipbook-preview-view-toggle button.active,\n.studio-flipbook-preview-orientation-toggle button.active {\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.studio-flipbook-preview-view-toggle button:hover:not(.active),\n.studio-flipbook-preview-orientation-toggle button:hover:not(.active) {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n@media (max-width: 720px) {\n  .studio-flipbook-preview-orientation-toggle {\n    display: none;\n  }\n}\n\n.studio-flipbook-preview-dl-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  border: none;\n  background: rgba(99, 102, 241, 0.8);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.studio-flipbook-preview-dl-btn:hover {\n  background: #6366f1;\n}\n\n.studio-flipbook-preview-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(255, 255, 255, 0.6);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.studio-flipbook-preview-close-btn:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.studio-flipbook-preview-stage-photo {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  padding: 24px 16px;\n  min-height: 0;\n}\n\n.studio-flipbook-preview-spotlight {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.studio-flipbook-preview-spotlight::after {\n  content: '';\n  width: 50%;\n  height: 60%;\n  border-radius: 50%;\n  background: rgba(99, 102, 241, 0.04);\n  filter: blur(100px);\n}\n\n.studio-flipbook-preview-nav-photo {\n  position: absolute;\n  z-index: 30;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(0, 0, 0, 0.2);\n  backdrop-filter: blur(4px);\n  padding: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n}\n\n.studio-flipbook-preview-nav-photo.prev { left: 16px; }\n.studio-flipbook-preview-nav-photo.next { right: 16px; }\n\n.studio-flipbook-preview-nav-photo:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.studio-flipbook-preview-nav-photo:disabled {\n  opacity: 0.2;\n  cursor: not-allowed;\n}\n\n.studio-flipbook-preview-book-wrap-photo {\n  position: relative;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.studio-flipbook-book-photo {\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 12px;\n  box-shadow: 0 30px 100px rgba(0, 0, 0, 0.6);\n}\n\n.studio-flipbook-book-photo .stf__parent {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.studio-flipbook-flip-page {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n  overflow: hidden;\n}\n\n.studio-flipbook-flip-page-inner {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.studio-flipbook-page-preview-frame {\n  position: relative;\n  z-index: 20;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  flex-shrink: 0;\n  box-shadow:\n    0 4px 8px rgba(0, 0, 0, 0.1),\n    0 20px 60px rgba(0, 0, 0, 0.3),\n    0 40px 100px -20px rgba(0, 0, 0, 0.5),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.05);\n}\n\n.studio-flipbook-page-outer--fill {\n  background: #fff;\n}\n\n.studio-flipbook-page-scaler {\n  line-height: 0;\n}\n\n.studio-flipbook-preview-size-hint {\n  color: rgba(255, 255, 255, 0.35);\n  font-weight: 500;\n  margin-left: 4px;\n}\n\n.studio-flipbook-preview-surface-shadow {\n  position: absolute;\n  bottom: 6%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 35%;\n  height: 16px;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 50%;\n  filter: blur(16px);\n  pointer-events: none;\n}\n\n.studio-flipbook-preview-bottombar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 24px;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(12px);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.studio-flipbook-preview-page-count {\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.studio-flipbook-preview-dots {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 40vw;\n  overflow-x: auto;\n  padding: 2px 4px;\n}\n\n.studio-flipbook-preview-dot {\n  flex-shrink: 0;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  border: none;\n  padding: 0;\n  background: rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.studio-flipbook-preview-dot.past {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.studio-flipbook-preview-dot.active {\n  width: 16px;\n  border-radius: 999px;\n  background: #818cf8;\n}\n\n.studio-flipbook-preview-hint {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.3);\n}\n\n/* legacy preview classes kept for compatibility */\n.studio-flipbook-preview-overlay.legacy {\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.studio-flipbook-preview-modal {\n  width: 90vw;\n  max-width: 1100px;\n  height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.studio-flipbook-preview-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  color: #fff;\n}\n\n.studio-flipbook-preview-header h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.studio-flipbook-preview-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.studio-flipbook-preview-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.studio-flipbook-preview-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.studio-flipbook-preview-close {\n  border: none;\n  background: transparent;\n  color: #fff;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 4px;\n}\n\n.studio-flipbook-preview-stage {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.studio-flipbook-preview-book-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.studio-flipbook-preview-nav {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 18px;\n}\n\n.studio-flipbook-preview-nav:disabled {\n  opacity: 0.2;\n  cursor: not-allowed;\n}\n\n.studio-flipbook-preview-nav:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.studio-flipbook-preview-footer {\n  text-align: center;\n  padding: 10px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 13px;\n}\n\n.studio-flipbook-preview-page {\n  background: #fff;\n}\n\n.studio-flipbook-book {\n  margin: 0 auto;\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);\n}\n\n.studio-flipbook-page-outer {\n  line-height: 0;\n}\n\n/* ─── responsive ─── */\n@media (max-width: 1100px) {\n  .studio-flipbook-right {\n    display: none;\n  }\n\n  .studio-flipbook-left {\n    width: 240px;\n  }\n}\n\n@media (max-width: 768px) {\n  .studio-flipbook-topbar {\n    height: auto;\n    min-height: 58px;\n    flex-wrap: wrap;\n    padding: 10px 12px;\n  }\n\n  .studio-flipbook-left {\n    display: none;\n  }\n\n  .studio-flipbook-center {\n    padding: 12px;\n  }\n\n  .studio-flipbook-canvas-wrap {\n    gap: 6px;\n  }\n\n  .studio-flipbook-nav {\n    width: 28px;\n    height: 28px;\n  }\n\n  .studio-flipbook-modal-overlay {\n    padding: 12px;\n  }\n\n  .studio-flipbook-choose-image-modal {\n    width: 96vw !important;\n    height: min(88vh, 480px) !important;\n    max-height: none !important;\n    border-radius: 14px;\n  }\n}\n\n@media (max-width: 420px) {\n  .studio-flipbook-choose-image-grid {\n    grid-template-columns: repeat(auto-fill, 88px);\n  }\n\n  .studio-flipbook-modal-thumb {\n    width: 88px;\n    height: 88px;\n  }\n\n  .studio-flipbook-topbar-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
